import * as Yup from "yup";

export const cotizacionSchema = () => {
  return Yup.object().shape({
    name: Yup.string()
      .required("This field is required")
      .trim(),
    email: Yup.string()
      .required("This field is required")
      .email("Invalid email address")
      .trim(),
    phone: Yup.string()
      .required("This field is required")
      .matches(
        /^\d{10}$/,
        "This field must contain only numbers and be exactly 10 digits long"
      )
      .trim(),
    serviceType: Yup.string()
      .required("This field is required")
      .trim(),
    address: Yup.string()
      .required("This field is required")
      .trim(),
    message: Yup.string()
      .required("This field is required")
      .trim(),
  });
};
